<div class="container mt-3">

  <!-- Tabla -->
    <div class="container py-4">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="card shadow-sm">
            <div class="card-header bg-primary text-white d-flex align-items-center justify-content-between">
              <h4 class="mb-0">Parámetros Financieros</h4>
              <i class="bi bi-cash-coin fs-3"></i>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover align-middle">
                  <thead class="table-light">
                    <tr>
                      <th>Código</th>
                      <th>Valor</th>
                      <th>Tipo</th>
                      <th>Fecha</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of paginated">
                      <td>{{ p.code }}</td>
                      <td>{{ p.value }}</td>
                      <td>{{ getTypeName(p.type) }}</td>
                      <td>{{ p.createdOn | date:'short' }}</td>
                      <td>
                        <button class="btn btn-outline-primary btn-sm" (click)="openModal(p)">
                          <i class="bi bi-pencil-square"></i> Actualizar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Paginación mejorada -->
              <nav class="d-flex justify-content-end mt-3">
                <ul class="pagination mb-0">
                  <li class="page-item" [class.disabled]="page === 1">
                    <button class="page-link" (click)="setPage(page - 1)" [disabled]="page === 1">Anterior</button>
                  </li>
                  <li class="page-item disabled">
                    <span class="page-link">Página {{ page }}</span>
                  </li>
                  <li class="page-item" [class.disabled]="page * pageSize >= parameters.length">
                    <button class="page-link" (click)="setPage(page + 1)" [disabled]="page * pageSize >= parameters.length">Siguiente</button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Modal de actualización -->
<app-financial-parameter-modal
  [showModal]="showModal"
  [selectedParam]="selectedParam"
  [newValue]="newValue"
  [errorMessage]="errorMessage"
  (close)="closeModal()"
  (saveValue)="save()"
  (valueChange)="newValue = $event"
></app-financial-parameter-modal>

